let storefrontQueries = {};

storefrontQueries.getProductById = function (productId) {
  return `{
    products(first: 1, query:"id:${productId}") {
      edges {
        node {
          id
          title
          handle
          tags
          description
          descriptionHtml
          keyBullets: metafield(namespace: "global", key: "keyBullets") {
            id
            value
          }
          header1: metafield(namespace: "global", key: "header1") {
            id
            value
          }
          header2: metafield(namespace: "global", key: "header2") {
            id
            value
          }
          warnings: metafield(namespace: "global", key: "warnings") {
            id
            value
          }
          suppl_prod: metafield(namespace: "global", key: "suppl_prod") {
            id
            value
          }
          specs2: metafield(namespace: "global", key: "specs2") {
            id
            value
          }
          tariff_charge: metafield(namespace: "global", key: "tariff_charge") {
            id
            value
          }
          variants(first: 50) {
            edges {
              node {
                id
                price { amount }
                compareAtPrice { amount }
                sku
                title
                quantityAvailable
                availableForSale
                selectedOptions {
                  name
                  value
                }
                image {
                  id
                  altText
                  originalSrc
                }
                header1: metafield(namespace: "global", key: "header1") {
                  id
                  value
                }      
                keyBullets: metafield(namespace: "global", key: "keyBullets") {
                  id
                  value
                }
                description: metafield(namespace: "custom_fields", key: "description") {
                  id
                  value
                }
                specs2: metafield(namespace: "global", key: "specs2") {
                  id
                  value
                }
                inTheBoxSkus: metafield(namespace: "global", key: "inTheBoxSkus") {
                  id
                  value
                }
                suppl_prod: metafield(namespace: "global", key: "suppl_prod") {
                  id
                  value
                }
                bundles: metafield(namespace: "global", key: "bundles") {
                  id
                  value
                }
                inStockMessage: metafield(namespace: "global", key: "inStockMessage") {
                  id
                  value
                }
                outOfStockMessage: metafield(namespace: "global", key: "outOfStockMessage") {
                  id
                  value
                }
                availability: metafield(namespace: "global", key: "availability") {
                  id
                  value
                }
                preorder_deposit: metafield(namespace: "global", key: "preorder_deposit") {
                  id
                  value
                }
                preorder_shipdate: metafield(namespace: "global", key: "preorder_shipdate") {
                  id
                  value
                }
                retail_price: metafield(namespace: "global", key: "retail_price") {
                  id
                  value
                }
                tariff_charge: metafield(namespace: "global", key: "tariff_charge") {
                  id
                  value
                }
              }
            }
          }
          images(first: 100) {
            edges {
              node {
                id
                altText
                originalSrc
              }
            }
          }
          options(first: 3) {
            id
            name
            values
          }
        }
      }
    }
  }
  `;
};

storefrontQueries.getProductByHandle = function (productHandle) {
  return `{
    productByHandle(handle: "${productHandle}") {
      id
      title
      handle
      tags
      description
      descriptionHtml
      keyBullets: metafield(namespace: "global", key: "keyBullets") {
        id
        value
      }
      header1: metafield(namespace: "global", key: "header1") {
        id
        value
      }
      header2: metafield(namespace: "global", key: "header2") {
        id
        value
      }
      warnings: metafield(namespace: "global", key: "warnings") {
        id
        value
      }
      specs2: metafield(namespace: "global", key: "specs2") {
        id
        value
      }
      variants(first: 12) {
        edges {
          node {
            id
            price{ amount }
            compareAtPrice{ amount }
            sku
            title
            availableForSale
            selectedOptions {
              name
              value
            }
            image {
              id
              altText
              originalSrc
            }
            specs2: metafield(namespace: "global", key: "specs2") {
              id
              value
            }
            inTheBoxSkus: metafield(namespace: "global", key: "inTheBoxSkus") {
              id
              value
            }
            suppl_prod: metafield(namespace: "global", key: "suppl_prod") {
              id
              value
            }
            bundles: metafield(namespace: "global", key: "bundles") {
              id
              value
            }
            inStockMessage: metafield(namespace: "global", key: "inStockMessage") {
              id
              value
            }
            outOfStockMessage: metafield(namespace: "global", key: "outOfStockMessage") {
              id
              value
            }
			availability: metafield(namespace: "global", key: "availability") {
              id
              value
            }
            preorder_deposit: metafield(namespace: "global", key: "preorder_deposit") {
              id
              value
            }
            retail_price: metafield(namespace: "global", key: "retail_price") {
              id
              value
            }
          }
        }
      }
      images(first: 10) {
        edges {
          node {
            id
            altText
            originalSrc
          }
        }
      }
      options(first: 3) {
        id
        name
        values
      }
    }
  }`;
};

storefrontQueries.getAccessories = function (commaSeparatedAccessories) {
  let formattedSkus = commaSeparatedAccessories
    .split(", ")
    .join(",")
    .split(",")
    .map((sku, skuIndex) => {
      return `productByHandle${skuIndex}: productByHandle(handle: "${sku
        .toLowerCase()
        .replace(" ", "-")}") {
        id
        title
        handle
        tags
        images(first: 1) {
          edges {
            node {
              id
              altText
              originalSrc
            }
          }
        }
        variants(first: 1) {
          edges {
            node {
              id
              sku
              compareAtPrice { amount }
              availableForSale
              priceV2 {
                amount
                currencyCode
              }
            }
          }
        }
      }
      `;
    });
  return `query {
    ${formattedSkus}
  }`;
};

storefrontQueries.productSearch = function (searchTerm) {
  return `{
    products(first: 50, query:"title:${searchTerm}*") {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          title
        }
      }
    }
  }`;
};
